"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spacer = _styledComponents.default.div.withConfig({
  displayName: "Spacer",
  componentId: "sc-1w7r4jn-0"
})(["", ""], function (p) {
  return p.width ? "width: ".concat(p.width, ";") : "\n    display: inline-flex;\n    flex-grow: 1;\n  ";
});

var _default = Spacer;
exports.default = _default;